var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-col",
    { staticClass: "flex" },
    [
      _c(
        "ib-row",
        [
          _c("ib-col", [
            _vm.showWarning === true && _vm.selectedDomain === "uk"
              ? _c(
                  "div",
                  { staticClass: "product-warning" },
                  [
                    _c(
                      "ib-infobox",
                      { attrs: { appearance: "sm", tone: "warning" } },
                      [_vm._v(_vm._s(_vm.$t("crypto_disclosure")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.status === "selected"
            ? _c("ib-col", [_c("Services", { ref: "services" })], 1)
            : _vm._e(),
          _c("ib-col", [
            _c(
              "div",
              [
                _c(
                  "ib-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectedTab === "products" &&
                          _vm.status === "selected",
                        expression:
                          "selectedTab === 'products' && status === 'selected'",
                      },
                    ],
                  },
                  [_c("ProductType", { ref: "productType" })],
                  1
                ),
                _c(
                  "ib-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.selectedTab === "products" &&
                            _vm.status === "selected") ||
                          (_vm.selectedTab === "exchanges" &&
                            _vm.status === "selected"),
                        expression:
                          "(selectedTab === 'products' && status === 'selected') || (selectedTab === 'exchanges' && status === 'selected')",
                      },
                    ],
                  },
                  [_c("SelectRegions")],
                  1
                ),
                _c(
                  "ib-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectedTab === "products" &&
                          _vm.status === "selected",
                        expression:
                          "selectedTab === 'products' && status === 'selected'",
                      },
                    ],
                  },
                  [_c("NewProduct", { ref: "newprod" })],
                  1
                ),
                _c(
                  "ib-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.selectedTab === "products" &&
                            _vm.status === "selected") ||
                          (_vm.selectedTab === "exchanges" &&
                            _vm.status === "selected") ||
                          (_vm.selectedTab === "contracts" &&
                            _vm.status === "selected"),
                        expression:
                          "(selectedTab === 'products' && status === 'selected') || (selectedTab === 'exchanges' && status === 'selected') || (selectedTab === 'contracts' && status === 'selected')",
                      },
                    ],
                  },
                  [_c("Search", { ref: "searchExchange" })],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.status === "selected" &&
          (_vm.selectedTab === "products" || _vm.selectedTab === "exchanges")
            ? _c("div", { staticClass: "text-left product-exchange" }, [
                _vm.$media.xl || _vm.$media.l || _vm.$media.m || _vm.$media.s
                  ? _c(
                      "span",
                      [
                        _c(
                          "ib-button",
                          {
                            staticClass: "inversed-black",
                            attrs: {
                              tone: "remove",
                              disabled: !_vm.canSubmit,
                              busy: _vm.loadingResult,
                            },
                            on: { click: _vm.getResults },
                          },
                          [_vm._v(_vm._s(_vm.$t("view_results")))]
                        ),
                        _c(
                          "ib-button",
                          {
                            staticClass: "fg-negative text-center inversed",
                            attrs: { tone: "border-remove" },
                            on: { click: _vm.resetFilters },
                          },
                          [_vm._v(_vm._s(_vm.$t("reset_filter")))]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c(
                          "ib-button",
                          {
                            staticClass: "text-center",
                            attrs: {
                              tone: "remove",
                              disabled: !_vm.canSubmit,
                              busy: _vm.loadingResult,
                              width: "100%",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("view_results")))]
                        ),
                        _c(
                          "ib-button",
                          {
                            staticClass: "fg-negative text-center inversed",
                            attrs: { tone: "border-remove", width: "100%" },
                            on: { click: _vm.resetFilters },
                          },
                          [_vm._v(_vm._s(_vm.$t("reset_filter")))]
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm.status === "filterResults" || _vm.status === "exchangeResults"
        ? _c(
            "ib-row",
            [
              _c("ib-col", { staticClass: "insety-8 results-options" }, [
                _c("div", { staticClass: "results-info" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("search_results")) + ": "),
                    _vm.status === "filterResults"
                      ? _c("span", { staticClass: "filtered-products" }, [
                          _vm._v(_vm._s(_vm.total.toLocaleString()) + " "),
                        ])
                      : _vm._e(),
                    _vm.status === "filterResults"
                      ? _c("span", { staticClass: "filter-text" }, [
                          _vm._v(_vm._s(_vm.$t("products_found"))),
                        ])
                      : _vm.status === "exchangeResults"
                      ? _c("span", { staticClass: "filtered-products" }, [
                          _vm._v(_vm._s(_vm.total)),
                        ])
                      : _vm._e(),
                    _vm.status === "exchangeResults"
                      ? _c("span", { staticClass: "filter-text" }, [
                          _vm._v(" " + _vm._s(_vm.$t("exchanges_found"))),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "filters" }, [
                    _vm.status === "filterResults"
                      ? _c("p", [
                          _vm._v(_vm._s(_vm.$t("product_type")) + ": "),
                          _c(
                            "span",
                            { staticClass: "filtered-product-types" },
                            [_vm._v(_vm._s(_vm.pdtTypes) + " ")]
                          ),
                          _c("span", [_vm._v(_vm._s(_vm.$t("region")) + ": ")]),
                          _c("span", { staticClass: "filter-text" }, [
                            _vm._v(_vm._s(_vm.selectedRegion) + " "),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.$t("filter")) + ": ")]),
                          _c("span", { staticClass: "filter-text" }, [
                            _vm._v(_vm._s(_vm.newProducts)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "ib-button",
                      {
                        staticClass: "dark-grey-text start",
                        attrs: { id: "download" },
                        on: { click: _vm.downloadMapping },
                      },
                      [_vm._v(_vm._s(_vm.$t("download_to_xls")))]
                    ),
                    _c(
                      "ib-button",
                      {
                        staticClass: "dark-grey-text start",
                        on: { click: _vm.startOver },
                      },
                      [_vm._v(_vm._s(_vm.$t("start_over")))]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.status === "filterResults" || _vm.status === "exchangeResults"
                ? _c(
                    "ib-col",
                    { staticClass: "productTypes" },
                    [
                      _c(
                        "ib-button",
                        {
                          staticClass: "selectAllType",
                          class: {
                            isActive: _vm.selectedProductType === "all",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.select("all")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "typeValue" }, [
                            _vm._v(_vm._s(_vm.$t("show_all"))),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "total" }, [
                            _vm._v(_vm._s(_vm.total.toLocaleString())),
                          ]),
                        ]
                      ),
                      _vm._l(_vm.types, function (product, index) {
                        return _c(
                          "ib-button",
                          {
                            key: index,
                            staticClass: "types",
                            class: {
                              isActive:
                                _vm.selectedProductType === product.symbol,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.select(product.symbol)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "typeValue" }, [
                              _vm._v(_vm._s(_vm.$t(product.name))),
                            ]),
                            _c("br"),
                            _c("span", { staticClass: "total" }, [
                              _vm._v(
                                _vm._s(product.totalCount.toLocaleString())
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.status === "exchangeResults" ? _c("ExchangeResults") : _vm._e(),
      _vm.status === "prodResults"
        ? _c("ProductResults", { ref: "productResults" })
        : _vm._e(),
      _vm.status === "filterResults" ? _c("ProductSearchResults") : _vm._e(),
      _vm.status === "loading"
        ? _c(
            "ib-row",
            [
              _c("ib-progress-circular", {
                staticClass: "alignment",
                attrs: { width: "128px", height: "128px" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }